<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  mounted() {
    this.renderChart(
      {
        labels: [
          "1399/1",
          "1399/2",
          "1399/3",
          "1399/4",
          "1399/5",
          "1399/6",
          "1399/7",
        ],
        datasets: [
          {
             label: "",
            data: [2, 10, 5, 9, 0, 6, 20],
            backgroundColor: "transparent",
            borderColor: "rgba(1, 116, 188, 0.50)",
            pointBackgroundColor: "rgba(171, 71, 188, 1)",
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "تعداد رزرو تائید شده",
        },
      }
    );
  },
};
</script>